<template>
  <div class='spinner-box'>
    <canvas id="spinner" class='spinner-canvas'></canvas>
  </div>
</template>

<script>
export default {
  mounted(){
    this.canvas = document.getElementById('spinner')
    this.context = this.canvas.getContext('2d')
    this.startSpin();
  },  
  data: () => ({
    canvas: null,
    context: null,
    x: null, 
    y: null, 
    width: null, 
    radius: null,
    tick: 0, 
    acc: 0, 
    startTime: 0, 
    frameTime: 0, 
    timeLast: 0,
    hue: 0, 
    head: 0, 
    tail: 180,
    rad: Math.PI / 180,
    rafid: null,
    colors: ['35ad0e', 'd8ad44', 'd00324', 'dc00b8', '017efc'].map(function(color)
      {
        return {
          r: parseInt(color.substring(0, 2), 16),
          g: parseInt(color.substring(2, 4), 16),
          b: parseInt(color.substring(4, 6), 16)
        };
      })    
  }),
  methods: {
    spin(t)
    {
      var duration = 1000;
      var tail_duration = duration*2.5;
      var timeCurrent = t||(new Date).getTime();
      if (!this.startTime) {
        this.startTime = timeCurrent;
      }
      this.tick = timeCurrent-this.startTime;
    
      this.acc = this.easeInOutQuad((this.tick+tail_duration/2)%tail_duration, 0, duration, tail_duration);
      this.head = this.easeLinear((this.tick+this.acc)%duration, 0, 360, duration);
      this.tail = 20+Math.abs(this.easeLinear((this.tick+tail_duration/2)%tail_duration, -300, 600, tail_duration));
    
      this.spinnerSize();
      this.context = this.canvas.getContext('2d')
      this.context.strokeStyle = this.spinColors(this.tick, duration);
      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.context.beginPath();
      this.context.arc(this.x, this.y, this.radius, parseInt(this.head-this.tail)%360*this.rad, parseInt(this.head)%360*this.rad, false);
      this.context.stroke();
    
      this.rafid = requestAnimationFrame(this.spin);
    },
    spinColors(currentIteration, totalIterations)
    {
      var oldstep = 0;
      var step = currentIteration%totalIterations;

      if (step < oldstep)
        this.colors.push(this.colors.shift());
      var c0 = this.colors[0],
      c1 = this.colors[1],
      r = this.minmax(this.easeLinear(step, c0.r, c1.r - c0.r, totalIterations), c0.r, c1.r),
      g = this.minmax(this.easeLinear(step, c0.g, c1.g - c0.g, totalIterations), c0.g, c1.g),
      b = this.minmax(this.easeLinear(step, c0.b, c1.b - c0.b, totalIterations), c0.b, c1.b);
    
      oldstep = step;
      return "rgb("+parseInt(r)+","+parseInt(g)+","+parseInt(b)+")";
    },
    spinnerSize()
    {
      this.canvas.width = this.canvas.offsetWidth;
      this.canvas.height = this.canvas.offsetHeight;
    
      this.x = this.canvas.width / 2;
      this.y = this.canvas.height / 2;
      this.width = Math.min(this.x, this.y)*0.25;
      this.radius = 3*this.width; //Math.min(x,y) - width;
    
      this.context.lineWidth = this.width;
      this.context.lineCap = "round";
    
    },
    startSpin()
    {
      this.startTime = 0;
      this.oldStep = 0;
      this.rafid = requestAnimationFrame(this.spin);
    },
    stopSpin()
    {
      cancelAnimationFrame(this.rafid);
    },
    minmax(value, v0, v1)
    {
      var min = Math.min(v0, v1);
      var max = Math.max(v0, v1);
      if (value < min)
        return min;
      if (value > max)
        return min;
      return value;
    },
      /*
      https://www.kirupa.com/html/animating_with_easing_functions_in_javascript.htm
    */
    easeLinear(currentIteration, startValue, changeInValue, totalIterations)
    {
      return changeInValue * currentIteration / totalIterations + startValue;
    },
    easeInOutQuad(currentIteration, startValue, changeInValue, totalIterations)
    {
      if ((currentIteration /= totalIterations / 2) < 1)
      {
        return changeInValue / 2 * currentIteration * currentIteration + startValue;
      }
      return -changeInValue / 2 * ((--currentIteration) * (currentIteration - 2) - 1) + startValue;
    }
    
    // startSpin();
  },
}
</script>

<style>
</style>